import React from 'react'
import PropTypes from 'prop-types'

export default function focusable(WrappedComponent) {
  return class Focusable extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        hasFocus: false,
      }
      this.instance = null
      this.enabled = true
    }

    componentWillUnmount() {
      this.enabled = false
    }

    setFocus = () => {
      if (!this.enabled) return

      if (this?.instance?.setChildFocus) {
        this.instance.setChildFocus()
        return
      }

      this?.instance?.onFocus?.() // only call onFocus if it's a defined method

      this?.instance?.readText?.()

      window?.focusedComponent?.props?.removeFocus?.()

      if (this.instance) {
        window.focusedComponent = this.instance
        this.setState({ hasFocus: true })
      } else {
        return
      }
    }

    removeFocus = () => {
      if (!this.enabled) return

      this.setState({ hasFocus: false })
    }

    isFocused = () => this.state.hasFocus

    setRef = (ref) => {
      this.instance = ref
    }
    render() {
      return (
        <WrappedComponent
          setFocus={this.setFocus}
          removeFocus={this.removeFocus}
          hasFocus={this.state.hasFocus}
          ref={this.setRef}
          {...this.props}
        />
      )
    }
  }
}

focusable.propTypes = {
  setFocus: PropTypes.func,
  removeFocus: PropTypes.func,
  hasFocus: PropTypes.bool,
}
